import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractWebSocketService, WebSocketServiceConfig, WebSocketRequestOptions } from 'types';
import { HWServiceConfig } from './hw-service-config';

@Injectable()
export abstract class BarcodeScannerService {
  abstract init(): Observable<void>;
  abstract done(): Observable<void>;
  abstract get messages$(): Observable<string>;
  abstract get binaryMessages$(): Observable<Uint8Array>;
}

@Injectable()
export class BuiltinBarcodeScannerService extends AbstractWebSocketService implements BarcodeScannerService {
  public constructor(config: HWServiceConfig) {
    super(new WebSocketServiceConfig(config.getHWServiceUrl(), config.getBCScannerServiceProtocol()));
  }

  public init(): Observable<void> {
    return this.ensureConnected();
  }

  public done(): Observable<void> {
    return this.disconnect();
  }

  private messagesOfType<T>(convert: (b: Blob) => Promise<T>): Observable<T> {
    return new Observable<T>((o) => {
      let subscription = this.sendRequest({ command: 'read', progress: false }, { expectedJsons: 1, expectedBlobs: 1000 }).subscribe({
        next(r) {
          if (r instanceof Blob) {
            convert(r).then((bc) => {
              o.next(bc);
              o.complete();
            });
          }
        },
        error(err) {
          o.error(err);
        },
        complete() {
          o.complete();
        },
      });
      return () => {
        subscription.unsubscribe();
        this.sendRequest({ command: 'stop-reading', progress: false }, new WebSocketRequestOptions()).subscribe();
      };
    });
  }

  public get messages$(): Observable<string> {
    return this.messagesOfType((b) => b.text());
  }

  public get binaryMessages$(): Observable<Uint8Array> {
    return this.messagesOfType((b) => b.arrayBuffer().then((a) => new Uint8Array(a)));
  }
}
